import * as React from 'react'
import styled from 'styled-components'

const Footer = styled.footer``

export default props => (
  <Footer {...props}>&copy; Hurley Medical Center {(new Date()).getFullYear()}</Footer>
)
